import React, { useMemo } from 'react';
import { useI18n } from '../../i18n/I18nContext';

// Helper to generate flag emoji from ISO 2-letter country code
const getFlagEmoji = (countryCode) => {
    if (!countryCode || countryCode.length !== 2) return '';
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
};

function CountrySelector({ value, onChange, name = 'country', id = 'country', required = false, label = '' }) {
    const { t } = useI18n();

    // Get all countries from i18n and sort them by name
    const sortedCountries = useMemo(() => {
        const countryData = t('client.countries');
        if (!countryData || typeof countryData !== 'object') return [];

        return Object.entries(countryData)
            .map(([code, name]) => ({
                code,
                name,
                flag: getFlagEmoji(code)
            }))
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [t]);

    return (
        <div className="form-floating">
            <select
                className="form-select"
                id={id}
                name={name}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                required={required}
            >
                <option value="">{t('common.select')}</option>
                {sortedCountries.map((country) => (
                    <option key={country.code} value={country.code}>
                        {country.flag} {country.name}
                    </option>
                ))}
            </select>
            {label && <label htmlFor={id}>{label}</label>}
        </div>
    );
}

export default CountrySelector;
